import PropTypes from 'prop-types';
import React from 'react';
import { observer } from 'mobx-react';
import { IconButton } from '@99designs/common/components/IconButton';
import { Icon } from '@99designs/common/components/Icon';

const ENTER_KEYCODE = 13;

class SearchInput extends React.Component {
    constructor(props) {
        super(props);

        this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    handleKeyPress(e) {
        if (e.which === ENTER_KEYCODE) {
            e.preventDefault();
        }
    }

    clearButton() {
        if (this.props.value.length === 0) return null;
        return (
            <IconButton onClick={this.props.onClear}>
                <Icon type={'x-3'} />
            </IconButton>
        );
    }

    subtitle() {
        if (!this.props.subtitle) return null;
        return <div className="field__message">{this.props.subtitle}</div>;
    }

    render() {
        return (
            <div className="field field--icon-label field--search-input">
                <div className="field__input">
                    <label className="field__title" htmlFor={this.props.id}>
                        <Icon type={'search-1'} />
                    </label>
                    <input
                        name={this.props.name}
                        id={this.props.id}
                        type="search"
                        autoCapitalize="off"
                        autoComplete="off"
                        className="input-search"
                        placeholder={this.props.placeholder}
                        onChange={this.props.onChange}
                        onKeyPress={this.handleKeyPress}
                        value={this.props.value}
                    />
                    <div className="field__input__action">{this.clearButton()}</div>
                </div>
                {this.subtitle()}
            </div>
        );
    }
}

SearchInput.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    subtitle: PropTypes.string,
};

SearchInput.defaultProps = {
    subtitle: '',
};

export default observer(SearchInput);



// WEBPACK FOOTER //
// ./src/js/components/SearchInput.jsx